import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import {
    PQR_RECEIVED_THROUGH,
    PQR_RECEIVED_THROUGH_DETAIL,
} from '../../../../../routes/paths';
import {
    asyncGetParam,
    asyncGetPqrReceivedThroughHistorical,
    asyncPatchPqrReceivedThroughParam,
    asyncPostPqrReceivedThroughParam,
} from '../../../../../services/param.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { Param, ParamHistorical } from '../../../../../shared/types/param';

export const usePqrReceivedThroughForm = () => {
    const navigate = useNavigate();
    const { idReceivedThrough } = useParams();
    const [pqrReceivedThrough, setPqrReceivedThrough] = useState<Param>();
    const [loading, setLoading] = useState(false);
    const [formikPqrReceivedThroughData, setFormikPqrReceivedThroughData] =
        useState<FormikProps<Param>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [pqrReceivedThroughHistorical, setSuptypeDPHistorical] =
        useState<ParamHistorical[]>();

    const isValidForm = formikPqrReceivedThroughData?.isValid;

    const handleCleanAndBack = () => {
        formikPqrReceivedThroughData?.resetForm();
        navigate(PQR_RECEIVED_THROUGH);
    };

    const handleSubmit = async () => {
        await formikPqrReceivedThroughData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Param = formikPqrReceivedThroughData?.values;

        let res: any | undefined = undefined;

        try {
            if (pqrReceivedThrough && pqrReceivedThrough.id)
                res = await asyncPatchPqrReceivedThroughParam(
                    pqrReceivedThrough.id,
                    data
                );
            else res = await asyncPostPqrReceivedThroughParam(data);
        } catch (error) {}
        if (res?.items) {
            const item = Array.isArray(res?.items) ? res?.items[0] : res?.items;
            ToastSwal.fire({
                text: `¡Felicidades! el medio PQR se ${
                    pqrReceivedThrough && pqrReceivedThrough.id
                        ? 'actualizo'
                        : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${PQR_RECEIVED_THROUGH_DETAIL}/${item.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    pqrReceivedThrough && pqrReceivedThrough.id
                        ? 'actualizar'
                        : 'crear'
                } el medio PQR. Por favor, asegúrate de ${
                    pqrReceivedThrough && pqrReceivedThrough.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idReceivedThrough)) {
            setLoading(true);
            asyncGetParam(idReceivedThrough)
                .then((pqrReceivedThrough: any) => {
                    if (!pqrReceivedThrough || !pqrReceivedThrough.items)
                        navigate(PQR_RECEIVED_THROUGH);
                    setPqrReceivedThrough(pqrReceivedThrough?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idReceivedThrough]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetPqrReceivedThroughHistorical(idReceivedThrough)
                .then((resp) => {
                    if (resp) setSuptypeDPHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        pqrReceivedThrough,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikPqrReceivedThroughData,
        pqrReceivedThroughHistorical,
        showHistorical,
        setShowHistorical,
    };
};
